import React from 'react'

export function LazyText() {
    return (
        <p className="text-lg text-gray-600">Please wait while we load the content for you.</p>
    )
}
